// Import React.
import React from "react";



// Export the landing page header.
export const LandingHeader = ({
    logo,
    signInUrl,
    createAccountUrl,
    displayFAQ = true,
}) => {


    // Scroll smoothly to the FAQ section.
    const handleFaqClick = () => {

        // Find the FAQ section in the page.
        const faqSection = document.getElementById("faq");

        // Stop when the FAQ section cannot be found.
        if (!faqSection) {

            // Exit the handler.
            return;

        }

        // Scroll the FAQ section into view.
        faqSection.scrollIntoView({

            // Animate the scroll.
            behavior: "smooth",

            // Position the FAQ section at the top.
            block: "start",

        });

    };



    // Render the header.
    return (

        // Render the outer site header.
        <header className="landing-header">

            {/* Constrain the header contents to the main page width. */}
            <div className="landing-header__inner">

                {/* Link the logo back to the landing page. */}
                <a
                    className="landing-header__logo-link"
                    href="/"
                    aria-label="StrichSuite home"
                >

                    {/* Render the supplied brand logo. */}
                    <img
                        className="landing-header__logo"
                        src={logo?.src}
                        alt={logo?.alt ?? "StrichSuite"}
                    />

                </a>

                {/* Render the header navigation. */}
                <nav
                    className="landing-header__navigation"
                    aria-label="Main navigation"
                >

                    {/* Scroll to the FAQ section without changing page. */}
                    {displayFAQ &&
                        
                        <button
                            className="landing-header__text-link"
                            type="button"
                            onClick={handleFaqClick}
                        >
                            FAQ
                        </button>

                    }

                    {/* Link existing users to the login page. */}
                    <a
                        className="landing-header__text-link"
                        href={signInUrl}
                    >
                        Sign In
                    </a>

                    {/* Display the primary account creation call to action. */}
                    <a
                        className="landing-header__button"
                        href={createAccountUrl}
                    >
                        Create Account
                    </a>

                </nav>

            </div>

        </header>

    );

};